import { render, staticRenderFns } from "./stocking_report.vue?vue&type=template&id=2979b1aa"
import script from "./stocking_report.vue?vue&type=script&lang=js"
export * from "./stocking_report.vue?vue&type=script&lang=js"
import style0 from "./stocking_report.vue?vue&type=style&index=0&id=2979b1aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports